var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 14.6667L11.4493 11.4497M11.4493 11.4497C11.9996 10.8994 12.4361 10.2461 12.7339 9.52714C13.0317 8.80816 13.185 8.03757 13.185 7.25935C13.185 6.48114 13.0317 5.71054 12.7339 4.99157C12.4361 4.27259 11.9996 3.61931 11.4493 3.06903C10.8991 2.51875 10.2458 2.08224 9.5268 1.78443C8.80783 1.48662 8.03723 1.33334 7.25902 1.33334C6.4808 1.33334 5.71021 1.48662 4.99123 1.78443C4.27226 2.08224 3.61898 2.51875 3.0687 3.06903C1.95735 4.18037 1.33301 5.68768 1.33301 7.25935C1.33301 8.83103 1.95735 10.3383 3.0687 11.4497C4.18004 12.561 5.68734 13.1854 7.25902 13.1854C8.83069 13.1854 10.338 12.561 11.4493 11.4497Z",
    stroke: "#27265C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.89d4a9fbf8bbd3b5a30c2cfec37db7e4.svg";
export { ForwardRef as ReactComponent };